import React from 'react'
import withProps from 'recompose/withProps'
import styled from 'react-emotion'
import { mediumMediaQuery, largeMediaQuery } from 'utils/style-helpers'
import SmartLink from 'components/SmartLink'

const Container = styled.div`
  position: relative;
`

const List = styled.ul`
  background: #fff;
  color: #4caf50;
  display: ${props => props['data-menu-active'] ? 'block' : 'none'};
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0;
  top: 100%;

  ${mediumMediaQuery} {
    align-items: center;
    background: none;
    display: flex;
    justify-content: flex-end;
    margin-left: 30px;
    position: static;
  }
`

const ListItem = styled.li`
  border-bottom: 1px solid #4caf50;
  display: block;
  margin: 0;
  text-align: right;

  &:last-child {
    border-bottom: none;
  }

  ${mediumMediaQuery} {
    border-bottom: none;
    display: inline-block;
    margin-left: 30px;
    text-align: left;

    &:first-child {
      margin-left: 0;
    }
  }

  ${largeMediaQuery} {
    margin-left: 60px;
  }
`

const ItemLink = styled(SmartLink)`
  color: #4caf50;
  display: block;
  font-size: 14px;
  letter-spacing: 2.4px;
  padding: 20px;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;

  ${mediumMediaQuery} {
    color: #fff;
    font-size: 12px;
    padding: 0;
    white-space: normal;
  }
`

const LoginButton = styled(ItemLink)`
  ${mediumMediaQuery} {
    background: transparent;
    border: 3px solid #fff;
    border-radius: 9999px;
    display: block;
    height: 48px;
    line-height: 44px;
    text-align: center;
    width: 160px;
  }
`

const Toggler = withProps({
  href: '#'
})(styled.a`
  background: #fff;
  color: #4caf50;
  display: inline-block;
  font-size: 14px;
  padding: 16px 20px;
  text-decoration: none;
  text-transform: uppercase;

  ${mediumMediaQuery} {
    display: none;
  }
`)

class SiteLinks extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuActive: false
    }

    this.handleToggle = this.handleToggle.bind(this)
  }

  render() {
    return (
      <Container>
        <Toggler onClick={this.handleToggle}>Menu</Toggler>
        <List data-menu-active={this.state.menuActive}>
          <ListItem><ItemLink href="#how-it-works">How It Works</ItemLink></ListItem>
          <ListItem><ItemLink to="/why-chouxbox">Why Chouxbox</ItemLink></ListItem>
          <ListItem><LoginButton href="https://app.chouxbox.com">Log In</LoginButton></ListItem>
        </List>
      </Container>
    )
  }

  handleToggle(e) {
    e.preventDefault()
    this.setState({
      menuActive: !this.state.menuActive
    })
  }
}

export default SiteLinks



// WEBPACK FOOTER //
// ./src/components/NavBar/SiteLinks/index.js